document.addEventListener("DOMContentLoaded", () => {

  // ⭐ Force autoplay, muted, loop, playsinline through JS
  document.querySelectorAll(".multi-collection-image-col video").forEach(video => {
    video.muted = true;
    video.loop = true;
    video.autoplay = true;
    video.playsInline = true;

    // Force play
    video.play().catch(() => {});
  });

  // ▶️ Play / Pause button
  document.querySelectorAll(".pro-with-video-btn").forEach(btn => {
    btn.addEventListener("click", function () {

      const parent = this.closest(".multi-collection-image-col");
      const video = parent.querySelector("video");

      if (!video) return;

      if (video.paused) {
        video.play();
        parent.classList.add("play-video");
      } else {
        video.pause();
        parent.classList.remove("play-video");
      }
    });
  });

  // ⛶ Fullscreen button
  document.querySelectorAll(".pro-with-video-crop-btn").forEach(btn => {
    btn.addEventListener("click", function () {

      const parent = this.closest(".multi-collection-image-col");
      const video = parent.querySelector("video");
      if (!video) return;

      if (!document.fullscreenElement) {
        video.requestFullscreen();
      } else {
        document.exitFullscreen();
      }
    });
  });

});
